<template>
  <form @submit.prevent="log" @keyup.tab="tabUsed=true">
    <accordian>
      <div class="active" ref="student" @input="change($event,'reason')">
        <div class="acc-header">{{student}}</div>
        <quick-pick ref="studentInput" class="acc-body" v-model="student" :list="students" :quicklist="studentsQuick"></quick-pick>
      </div>
      <div ref="reason">
        <div class="acc-header">{{reason.slice(0,23)}}{{reason.length>23?'...':''}}</div>
        <div class="acc-body">
          <textarea v-model="reason" cols="30" rows="10"></textarea>
        </div>
      </div>
      <div ref="other">
        <div class="acc-header">{{giver}} on {{date}}</div>
        <div class="acc-body">
          <quick-pick v-model="giver" :list="staff" :quicklist="[]"></quick-pick>
          <Flatpickr v-model="date" :options="{onReady:(d,s,i)=>i.setDate(s,1)}"></Flatpickr>
        </div>
      </div>
    </accordian>
    <button type="submit" class="pure-button pure-button-primary submit">Submit</button>
  </form>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import quickPick from 'components/quick-pick.vue'
import accordian from 'components/accordian.vue'
import Flatpickr from 'vue-flatpickr/vue-flatpickr-base16.vue'
import report from '../mixins/report'

export default {
  components:{
    quickPick,
    Flatpickr,
    accordian
  },
  data () {
    return {
      student:'',
      reason:'',
      giver:'',
      date:Date(),
      tabUsed:false
    }
  },
  methods:{
    change(e,ref){
      e.currentTarget.classList.remove('active');
      this.$refs[ref].classList.add('active');
    },
    log(){
      var vm=this;
      if(vm.student&&vm.reason){
        vm.$el.querySelector('.active').classList.remove('active');
        vm.$refs.student.classList.add('active');
        if(vm.tabUsed)vm.$refs.studentInput.$emit('focus');
        report({type:'honor',student:vm.student,reason:vm.reason,teacher:vm.giver,date:vm.date});
        vm.student='';
        vm.reason='';
      }
    }
  },
  watch:{
    'student':function(nv,ov){
      
    }
  },
  computed:{
    ...mapState({
      students:'students',
      studentsQuick:'studentsQuick',
      teacher:'teacher',
      staff:'staff'
    })
  },
  mounted(){
    this.giver=this.teacher;
  }
}
</script>
<style>
textarea{
  max-width:95%;
}
form>button.submit{
  width:80%;
  max-width:300px;
  display:block;
  margin:0 auto;
}
</style>


// WEBPACK FOOTER //
// Honor.vue?1a6cb180